<template>
    <div>
        <video :width="width" :height="height" :controls="controls" :autoplay="autoplay" v-if="_url">
            <source :src="_url" type="video/mp4">
            <source :src="_url" type="video/ogg">
            Your browser does not support the video tag.
        </video>
    </div>
</template>

<script>
export default {
    /**
        tag
        name: ks-video-player
        description: ks-video-player
    **/
    name: "video-player",
    props: {
        /**
            attribute
            name: url 
            description: url
        **/
        url:{
            type: String,
            required: true
        },
        /**
            attribute
            name: private
            description: add app token
        **/
        private: {
            type: Boolean,
            default: false
        },
        /**
            attribute
            name: width 
            description: width
        **/
        width:{
            type: String,
            default: '500'
        },
        /**
            attribute
            name: height 
            description: height
        **/
        height:{
            type: String,
            default: '500'
        },
        /**
            attribute
            name: controls 
            description: controls
        **/
        controls:{
            type: Boolean,
            default: true
        },
        /**
            attribute
            name: autoplay 
            description: autoplay
        **/
        autoplay:{
            type: Boolean,
            default: false
        }
    },
    computed:{
        _url(){
            return `${this.url}${this.private?`?token=${app.auth.urlToken}`:''}`;
        }
    } 
};
</script>
